import { NavigateFunction, NavigateOptions } from "react-router-dom";

import { DYNAMIC_ROUTES_CONSTANT, ROUTES } from "../constants/RouteConstants";

const {
  ADD_QUESTION_ROUTE,
  CANDIDATE_LOGIN_ROUTE,
  CANDIDATE_WAIT_ROUTE,
  CREATED_IMPORT_QUESTIONS_ROUTE,
  DOSELECT_FEEDBACK_ROUTE,
  IMPORT_QUESTION_ROUTE,
  INTERVIEW_FEEDBACK_ROUTE,
  LANDING_ROUTE,
  LOBBY_ROUTE,
  NOT_FOUND_ROUTE,
  QUESTION_ROUTE,
} = ROUTES;
const { ACCESS_CODE, INTERVIEW_SLUG, QUESTION_SLUG } = DYNAMIC_ROUTES_CONSTANT;

export const goToAddQuestionRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = ADD_QUESTION_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToCandidateLoginRoute = (
  navigate: NavigateFunction,
  accessCode: string,
  options?: NavigateOptions,
) => {
  const route = CANDIDATE_LOGIN_ROUTE.replace(ACCESS_CODE, accessCode);
  navigate(route, options);
};

export const goToCandidateWaitRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = CANDIDATE_WAIT_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToCreatedImportQuestionRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  questionSlug: string,
  options?: NavigateOptions,
) => {
  const route = CREATED_IMPORT_QUESTIONS_ROUTE.replace(
    INTERVIEW_SLUG,
    interviewSlug,
  ).replace(QUESTION_SLUG, questionSlug);
  navigate(route, options);
};

export const goToDoSelectFeedbackRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = DOSELECT_FEEDBACK_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToImporteQuestionRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = IMPORT_QUESTION_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToInterviewFeedbackRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = INTERVIEW_FEEDBACK_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToLandingRoute = (
  navigate: NavigateFunction,
  accessCode: string,
  options?: NavigateOptions,
) => {
  const route = LANDING_ROUTE.replace(ACCESS_CODE, accessCode);
  navigate(route, options);
};

export const goToLobbyRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  options?: NavigateOptions,
) => {
  const route = LOBBY_ROUTE.replace(INTERVIEW_SLUG, interviewSlug);
  navigate(route, options);
};

export const goToNotFoundRoute = (
  navigate: NavigateFunction,
  options?: NavigateOptions,
) => {
  navigate(NOT_FOUND_ROUTE, options);
};

export const goToQuestionRoute = (
  navigate: NavigateFunction,
  interviewSlug: string,
  questionSlug: string,
  options?: NavigateOptions,
) => {
  const route = QUESTION_ROUTE.replace(INTERVIEW_SLUG, interviewSlug).replace(
    QUESTION_SLUG,
    questionSlug,
  );
  navigate(route, options);
};
